import {
  CircleCheckIcon,
  InfoIcon,
  Loader2Icon,
  OctagonXIcon,
  TriangleAlertIcon,
} from "lucide-react"
import { Toaster as Sonner } from "sonner"

const Toaster = ({ ...props }) => {

  return (
    <Sonner
      className="toaster group"
      toastOptions={{
        classNames: {
          toast: "group toast group-[.toaster]:bg-black group-[.toaster]:text-white group-[.toaster]:border-border group-[.toaster]:shadow-lg data-[type=success]:!bg-green-600 data-[type=success]:!text-white data-[type=error]:!bg-red-600 data-[type=error]:!text-white data-[type=warning]:!bg-zinc-800 data-[type=warning]:!text-white data-[type=info]:!bg-blue-500 data-[type=info]:!text-white",
          description: "group-[.toast]:!text-white",
          actionButton: "group-[.toast]:bg-white group-[.toast]:text-black group-[.toast]:font-semibold",
          cancelButton: "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      icons={{
        success: <CircleCheckIcon className="size-4" />,
        info: <InfoIcon className="size-4" />,
        warning: <TriangleAlertIcon className="size-4" />,
        error: <OctagonXIcon className="size-4" />,
        loading: <Loader2Icon className="size-4 animate-spin" />,
      }}
      {...props}
    />
  )
}

export { Toaster }
